export function formatError(error: unknown) {
  let exception = new Error('Something went wrong')

  if (error) {
    if (error instanceof Error) {
      exception = error
    } else if (typeof error === 'object') {
      if ('message' in error && typeof error.message === 'string') {
        exception = new Error(error.message)
      } else if (
        'body' in error &&
        typeof error.body === 'object' &&
        error.body &&
        'message' in error.body &&
        typeof error.body.message === 'string'
      ) {
        exception = new Error(error.body.message)
      } else if (
        'error' in error &&
        typeof error.error === 'object' &&
        error.error &&
        'message' in error.error &&
        typeof error.error.message === 'string'
      ) {
        exception = new Error(error.error.message)
      }
    } else if (typeof error === 'string') {
      exception = new Error(error)
    }
  }

  return exception
}
